module.exports = __webpack_public_path__ + "media/images/linkedin-04d8993ccee49bcb3790319bf041dad9.svg";